import { render, staticRenderFns } from "./medicalReport.vue?vue&type=template&id=22b8c71a&scoped=true"
import script from "./medicalReport.vue?vue&type=script&lang=js"
export * from "./medicalReport.vue?vue&type=script&lang=js"
import style0 from "./medicalReport.vue?vue&type=style&index=0&id=22b8c71a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b8c71a",
  null
  
)

export default component.exports